import { getCustomer } from "@/graphql/schemas/shared/utils/getCustomer"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { mapCustomerAddressInformation } from "../utils/customerAddressInformation"

export const queryCustomerContactAddresses = {
  async customerContactAddresses(parent, args, context, info) {
    const { customerId, customerKey, customerNumber } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.ADDRESSES,
      operation: Operations.READ,
    })

    const customer = await getCustomer({ id: customerId, key: customerKey, number: customerNumber })

    await validateAccessRightsToCustomer({
      user: user,
      customerNumber: customer.customerNumber,
    })

    if (customer?.addresses?.lenght <= 0) return null

    const customerAddresses = customer.addresses || []

    // combine shipping and billing addresses, remove duplicates
    const billingAndShippingAddressIds = [
      ...new Set([...(customer?.billingAddressIds || []), ...(customer?.shippingAddressIds || [])]),
    ]

    // contact addresses are the ones that are not set as billing or shipping
    const contactAddresses = customerAddresses.filter((address) => !billingAndShippingAddressIds.includes(address.id))

    if (contactAddresses?.length <= 0) return null

    // mapp the contact addresses information with required and available fields
    const mappedContactAddresses = contactAddresses?.map((address) => {
      return mapCustomerAddressInformation(address, customer)
    })

    return { items: mappedContactAddresses, total: mappedContactAddresses?.length || 0 }
  },
}
